import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { ScheduleProvider } from './context/ScheduleContext';
import { ToastProvider } from './components/Common/Toast';
import { MainLayout } from './components/Layout/MainLayout';
import { ScheduleGrid } from './components/Grid/ScheduleGrid';
import { LoginForm } from './components/Auth/LoginForm';
import { ProtectedRoute } from './components/Auth/ProtectedRoute';
import { ShowManager } from './components/Admin/ShowManager';
import { EpisodeManager } from './components/Admin/EpisodeManager';
import { UserManager } from './components/Admin/UserManager';
import { PlaceholderPage } from './components/Common/PlaceholderPage';

function App() {
  return (
    <AuthProvider>
      <ScheduleProvider>
        <ToastProvider>
          <Routes>
            <Route path="/" element={<MainLayout />}>
              <Route index element={<ScheduleGrid />} />
              <Route
                path="admin"
                element={
                  <ProtectedRoute roles={['admin']}>
                    <PlaceholderPage title="Admin" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="admin/users"
                element={
                  <ProtectedRoute roles={['admin']}>
                    <UserManager />
                  </ProtectedRoute>
                }
              />
              <Route
                path="aide-memoire"
                element={
                  <ProtectedRoute roles={['admin', 'editor']}>
                    <PlaceholderPage title="Aide-Mémoire" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="meo"
                element={
                  <ProtectedRoute roles={['admin', 'editor']}>
                    <PlaceholderPage title="M.E.O." />
                  </ProtectedRoute>
                }
              />
              <Route
                path="cue-sheets"
                element={
                  <ProtectedRoute roles={['admin', 'editor']}>
                    <ShowManager />
                  </ProtectedRoute>
                }
              />
              <Route
                path="contact-telemag"
                element={<PlaceholderPage title="Contact Telemag" />}
              />
              <Route
                path="contact-reseaux"
                element={
                  <ProtectedRoute roles={['admin', 'editor']}>
                    <PlaceholderPage title="Contact Réseaux Câblo" />
                  </ProtectedRoute>
                }
              />
              <Route
                path="shows"
                element={
                  <ProtectedRoute roles={['admin', 'editor']}>
                    <ShowManager />
                  </ProtectedRoute>
                }
              />
              <Route
                path="shows/:showId/episodes"
                element={
                  <ProtectedRoute roles={['admin', 'editor']}>
                    <EpisodeManager />
                  </ProtectedRoute>
                }
              />
            </Route>
            <Route path="/login" element={<LoginForm />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ToastProvider>
      </ScheduleProvider>
    </AuthProvider>
  );
}

export default App;
